'use client';

import Image from 'next/image';

import { useTheme } from '@web/theme';

type Props = {
  forceTheme?: 'light' | 'dark';
};

export function LogoThemeAware({ forceTheme }: Props) {
  const { theme, resolvedTheme } = useTheme();
  const effectiveTheme =
    forceTheme ?? (theme === 'system' ? resolvedTheme : theme);

  const src =
    effectiveTheme === 'light'
      ? '/netnet-animated-logo-black-font.svg' // black text on light bg
      : '/netnet-animated-logo-white-font.svg'; // white text on dark bg

  return (
    <Image src={src} alt="Company Logo" width={140} height={40} priority />
  );
}
